// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// ⚠️ Unwrap the default export. @rails/ujs 7.1 ships two builds: a UMD one (`main`, which auto-starts on load)
// and an ESM one (`module`) whose only export is `export { Rails as default }`. Webpack prefers `module`, so
// `require("@rails/ujs")` returns the namespace object and `.start` is undefined -- the old bare
// `require("@rails/ujs").start()` threw "Rails.start is not a function", and that exception killed the REST OF
// THIS PACK: jQuery, Bootstrap, Turbolinks, I18n and every handler below simply never loaded. 6.1 shipped only
// the UMD build, which is why the old line worked. The `_rails_loaded` guard is belt-and-braces for the day
// the UMD build is resolved instead, since that one starts itself (UPGRADE_TODO 10.5k).
const ujs = require("@rails/ujs")
const Rails = ujs.default || ujs
if (!window._rails_loaded) Rails.start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
//require("@popperjs/core")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("bootstrap")

require("jquery-ui")
require("jquery-ui/ui/i18n/datepicker-fi.js")
import 'jquery-ui/themes/base/all.css'

require("timepicker/jquery.timepicker.min.js")
import 'timepicker/jquery.timepicker.min.css'

// Load Datatables
// 🚨 **`responsive` is an extension, not a core option, and it was configured for four years without being
// installed.** `"responsive": true` is set on all six tables; with this import missing the option was read by
// a plugin that was never there, so it did nothing and every index page overflowed at phone width —
// customers by +1037px at 390px wide (`TODO-ARCHIVE.md` F-19, measured 2026-10-07). Nothing reported it: a no-op
// option is silent, and the config read as if the behaviour were present.
// ⚠️ **Pinned at 2.x deliberately.** 2.5.1 requires core `^1.13.0`, which is the 1.13.4 in use; the 3.x and
// 4.x lines need core `^2` and `^3` and so are gated on `UPGRADE_TODO.md` 10.5l. All six DataTables packages
// are pinned together under `resolutions` in `package.json`, because `datatables.net-bs5` declares an
// open-ended `datatables.net: >=1.12.1` and will otherwise resolve a mismatched core underneath itself.
require('datatables.net-bs5')
require('datatables.net-buttons-bs5')
require('datatables.net-responsive-bs5')
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
import 'datatables.net-buttons-bs5/css/buttons.bootstrap5.css'
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.css'

import { Offcanvas, Modal } from 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css' // https://icons.getbootstrap.com/

import request from 'src/api'
//import select2 from 'select2'
require('select2') // https://select2.org/
require("select2/dist/js/i18n/fi.js")
import 'select2/dist/css/select2.min.css'
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css'

import 'css/site.scss'
import { showToasts, addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { isRole } from 'src/misc'

import clients_index from './clients/index'
import contract_people_index from './contract_people/index'
import customers_index from './customers/index'
import dashboard_admin from './dashboard/admin'
import dashboard_myyja from './dashboard/myyja'
import dashboard_pem from './dashboard/pem'
import { clientFunctions } from 'packs/clients/functions'
import users_index from './users/index'
import { userFunctions } from 'packs/users/functions'
import quality_controls_index from './quality_controls/index'
import quality_controls_laatu from './quality_controls/laatu'

import 'flag-icons/css/flag-icons.min.css'
import { I18n as I18nClass } from 'i18n-js/dist/import/I18n.js'
import translations from "../i18n/translations.json"
const currentLocale = document.querySelector('meta[name="current-locale"]')?.content || 'fi'
window.I18n = new I18nClass(translations, { locale: currentLocale })
I18n.translations = translations
I18n.locale = document.querySelector('meta[name="current-locale"]').content

let wentOffline = false
window.addEventListener('offline', function() {
  wentOffline = true
  addToast(I18n.t("errors.no_network"), 'error')
})
window.addEventListener('online', function() {
  if (wentOffline) {
    wentOffline = false
    addToast(I18n.t("errors.network_restored"), 'notice')
  }
})

$(document).ajaxError(function(event, jqxhr, settings, thrownError) {
  if (jqxhr.statusText === 'abort') return
  if (jqxhr.status === 0) {
    if (fullscreenLoader) fullscreenLoader.hide()
    addToast(navigator.onLine ? I18n.t("errors.unexpected_error") : I18n.t("errors.no_network"), 'error')
    return
  }
  if (jqxhr.status === 401) {
    if (Object.keys(jqxhr.responseJSON).length > 0) {
      // show ajax errors
      Object.keys(jqxhr.responseJSON).forEach(function(key) {
        addToast(jqxhr.responseJSON[key], key)
      })
      // redirect to root later
      setTimeout(function() {
        $.getScript('/redirect_to_root')
      }, 3000)
    } else {
      // no errors to show, redirect immediately
      $.getScript('/redirect_to_root')
    }
  }
})

// `document` survives a Turbolinks visit, so this is registered once at module scope like the listeners above
// and NOT inside turbolinks:load -- a delegated listener on document added per visit accumulates one copy per
// visit (F-83, same mechanism as F-82). select2 fires this on the <select>, which can sit in #content, the
// offcanvas or a modal, so document is the right target rather than any one container.
$(document).on("select2:open", () => {
  document.querySelector(".select2-container--open .select2-search__field").focus()
})

let sessionTimer
let sessionTimer2
window.addEventListener('beforeunload', function onBeforeUnload(e) {
  if (dirty) {
    e.preventDefault();
    e.returnValue = '';
    return;
  }

  delete e['returnValue'];
})
window.fullscreenLoader = null
window.mainModal = null
window.sessionModal = null
window.navTarget = null
window.offcanvasRight = null
window.dirty = false
// TODO.md T-102. **The index-table refresh hook — a no-op unless an index pack has claimed it.**
//
// 🔑 **Refresh on a successful SAVE, not on offcanvas close.** Closing cannot change what a row shows —
// only a save can, and the `dirty` guard already stops a silent close over unsaved edits. So "on close" is
// wrong in both directions: it fires when nothing changed, and it misses the close paths that are not a
// click (Esc, the backdrop), which is exactly what the QC schedule's own refetch was missing.
// ⚠️ **Deliberately NOT field-level change tracking**, which was the owner's question. That would be a
// per-table list of columns kept in step by hand with the forms that write them — the "two conditions that
// must agree" shape `CLAUDE.md` → *Role Guards* calls MANDATORY to avoid, and wrong the first time someone
// adds a column.
// 📌 **`ajax.reload(null, false)`** — the `false` is "do not reset paging", so the current page, ordering
// and scroll survive. One JSON request, not a page load.
// 📌 A global because the caller is a server-rendered `.js.erb`, which cannot import.
//
// 🚨 **Each claim must check its own table is still in the document, and `/code-review` caught that they
// did not.** An index pack claims this per visit and nothing restores the no-op, so after leaving an index
// page the hook still closed over that page's DataTable: an ADMIN could load `/customers`, navigate to
// `/dashboard`, save client settings from the sidebar offcanvas, and have `refreshIndexTable()` call
// `ajax.reload` on a table Turbolinks had already detached with `<body>` — a wasted request and a redraw of
// a detached node.
// 🔑 **Fixed in the CLAIM, not with a reset here.** Resetting at the top of `turbolinks:load` would work
// only while the packs are invoked after it — an ordering requirement `F-113` deliberately removed, and one
// that fails as a **dead page** rather than a double refresh. A claim that checks for its own table is
// order-free: the stale closure simply finds nothing and returns.
window.refreshIndexTable = function() {}
window.googleMap = null
window.keepLoaderOnModalClose = false   // set by hideModalKeepLoader() in src/lockButton
window.confirmDirtyNav = function(callback) {
  navTarget = callback
  $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("dirty_nav_modal.title") + '</h4></div><div class="modal-body text-center">' + I18n.t("dirty_nav_modal.body") + '</div><div class="modal-footer"><button id="modal-cancel" type="button" class="btn btn-secondary"><i class="bi bi-x"></i> ' + I18n.t("buttons.cancel") + '</button><button id="modal-dirty-continue" type="button" class="btn btn-danger"><i class="bi bi-arrow-right"></i> ' + I18n.t("buttons.continue") + '</button></div></div></div>')
  mainModal.show()
}

document.addEventListener("turbolinks:load", function() {
  // 📌 T-91 / F-113. `clientFunctions()` and `customerFunctions()` both run below for an ADMIN, so anything
  // they share is invoked twice. **Each shared module now makes its own binding idempotent with a namespaced
  // `off()`/`on()`** — see `src/historyLoadMore.js` and `packs/customers/functions_contact_person.js`.
  // ⚠️ A `resetClaims()` call used to have to be the **first statement in this listener**, because the
  // `claimOnce` registry it cleared was global and per-navigation. That ordering requirement is gone with
  // the registry (F-113, 2026-10-12), and its removal is the point: a pack adding its own `turbolinks:load`
  // listener would have produced a **dead page** rather than a double binding. Nothing here is
  // order-sensitive any more.

  const metaLocale = document.querySelector('meta[name="current-locale"]')?.content
  if (metaLocale && I18n.locale !== metaLocale) {
    I18n.locale = metaLocale
  }

  // only when signed in
  if ($("#content").length || $(".quality_controls.laatu").length) {
    // Turbolinks replaces the body but not pending timers, so an orphan countdown from the previous page would
    // keep ticking against a modal that no longer exists, and sign the user out (F-82).
    clearTimeout(sessionTimer2)
    setTimeoutTimer(1000)

    $('#sessionModal').on('click', '#modal_sign_out', function(event) {
      lockButton('#modal_sign_out')
      signOut('#modal_sign_out')
    })

    $('#sessionModal').on('click', '#modal_continue_session', function(event) {
      clearTimeout(sessionTimer2)
      lockButton('#modal_continue_session')

      request.put('/sessions/reset_user_clock')
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('text/javascript')
        .then(res => {
          setTimeoutTimer(1000)
          unlockButton('#modal_continue_session')
          sessionModal.hide()
        })
        .catch(err => {
          if (err.response && err.response.status === 401) {
            dirty = false
            window.location.href = '/'
          } else {
            handleErrors(err, '#modal_continue_session')
          }
        })
    })

    // https://api.jqueryui.com/datepicker/
    $.datepicker.setDefaults( $.datepicker.regional[ "fi" ] )
    $.datepicker.setDefaults({
      dateFormat: 'dd.mm.yy',
      firstDay: 1,
      showWeek : true
    })

    $.fn.dataTable.ext.errMode = 'none';

    // https://select2.org/
    $.fn.select2.defaults.set('language', 'fi')
    $.fn.select2.defaults.set('minimumInputLength', 3)
    $.fn.select2.defaults.set('selectionCssClass', ':all:')
    $.fn.select2.defaults.set('theme', 'bootstrap-5')

    const mainModalElement = document.getElementById('mainModal')
    mainModal = new Modal(mainModalElement, {
      backdrop: 'static',
      keyboard: false,
      focus: true
    })

    mainModalElement.addEventListener('hidden.bs.modal', function (event) {
      if (document.getElementById("googleMap")) {
        document.getElementById("googleMap").innerHTML = ""; // Remove map to prevent multiple instances
        googleMap = null;
      }

      if ($('#offcanvasRight').hasClass('show')) {
        $('body').css({ overflow: "hidden", paddingRight: "15px" })
      }

      // A close made by hideModalKeepLoader() belongs to a flow still waiting on a job: the loader
      // is that flow's to release. Every other close resets the loader along with the modal.
      if (window.keepLoaderOnModalClose) {
        window.keepLoaderOnModalClose = false
      } else {
        fullscreenLoader.hide()
      }
      $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold"></h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"></div></div></div>')
    })

    $('#mainModal').on('click', '#modal-cancel', function() {
      mainModal.hide()
    })

    $('#mainModal').on('click', '#modal-dirty-continue', function() {
      mainModal.hide()
      if (navTarget) {
        navTarget()
        navTarget = null
      }
    })

    const fullscreenLoaderElement = document.getElementById('fullscreenLoader')
    fullscreenLoader = new Modal(fullscreenLoaderElement, {
      backdrop: false,
      keyboard: false,
      focus: true
    })

    sessionModal = new Modal(document.getElementById('sessionModal'), {
      backdrop: 'static',
      keyboard: false,
      focus: true
    })

    if ($(".quality_controls.laatu").length) {
      $('header').on('click', '#sign-out', function(event) {
        lockButton('#sign-out')
        signOut('#sign-out')
      })

      quality_controls_laatu()
    } else {
      if (isRole('ADMIN')) {
        clientFunctions()
      }

      $('#user-info').on('click', '#sign-out', function(event) {
        lockButton('#sign-out')
        signOut('#sign-out')
      })

      let offcanvasRightElement = document.getElementById('offcanvasRight')
      if (offcanvasRightElement) {
        offcanvasRight = new Offcanvas(offcanvasRightElement)

        offcanvasRightElement.addEventListener('show.bs.offcanvas', function(e) {
          fullscreenLoader.show()
        })

        offcanvasRightElement.addEventListener('hidden.bs.offcanvas', function(e) {
          $("#offcanvasRight").html('')
          dirty = false
          mainModal.hide()
        })

        // Delegated from #offcanvasRight, not document: document survives a Turbolinks visit, so a listener
        // added here per visit accumulated one copy per visit and ran the handler N times on one click (F-83).
        // #offcanvasRight is replaced with the body, so this goes with it. Every #delete button is rendered by
        // layouts/_buttons into an .offcanvas-header, so it is always inside this container -- there is no
        // #delete anywhere else, the mobile laatu page included.
        $('#offcanvasRight').on('click', '#delete', function(event) {
          $(this).blur()
          const label = $(this).data('label')
          const name = $(this).data('name')
          const target = [label, name].filter(Boolean).join(' ')
          // 🚨 **TODO-ARCHIVE.md U-43. STORED XSS until 2026-10-14 — escaped in the attribute, handed back
          // DECODED, inserted as HTML.** `layouts/_buttons` renders `data: { name: delete_name }`, so Rails
          // escapes it correctly into the attribute (`data-name="&lt;img src=x onerror=…&gt;"`). **jQuery's
          // `.data()` returns the decoded value**, it was interpolated into the string below, and
          // `$("#mainModal").html(...)` parses it. Escaping the attribute protects the attribute, not the sink.
          // 🔑 **This is `U-42`'s mechanism with the unsafe step in JavaScript**, which is why the `html_safe`
          // audit that found `U-38` and `U-42` could not see it (`docs/SECURITY.md`).
          // ⚠️ The sources are user-written and the viewer is more privileged — the `F-118` shape:
          // `@customer.display_name` and a contract person's name, both editable by a **MYYJÄ**, rendered
          // into a modal an **ADMIN/PP/SUPER_ADMIN** opens.
          // 📌 `$('<span>').text(x).html()` is the escape: jQuery sets it as a text node and reads back the
          // serialised HTML. ⚠️ Do **not** instead drop the `<strong>` — the bolding is deliberate and
          // `I18n.t` is given markup on purpose; and do **not** escape in `_buttons`, where the attribute is
          // already correct and double-escaping would show `&lt;` to legitimate users.
          const safeTarget = $('<span>').text(target).html()
          const body = target ? I18n.t("delete_modal.body_with_name", { name: `<strong>${safeTarget}</strong>` }) : I18n.t("delete_modal.body")
          $("#mainModal").html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header text-center"><h4 class="modal-title w-100 font-weight-bold">' + I18n.t("delete_modal.title") + '</h4><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body">' + body + '</div><div class="modal-footer"><button id="confirmDelete" type="button" class="btn btn-danger"><i class="bi bi-trash"></i> ' + I18n.t("buttons.delete") + '</button></div></div></div>')
            mainModal.show()
        })

        $('#offcanvasRight').on('change', 'form input, form select, form textarea, form checkbox, form radio', function(event) {
          dirty = true
        })

        $('#offcanvasRight, #mainModal').on('click', 'button[type="submit"]', function(event) {
          fullscreenLoader.show()
        })

        $("#offcanvasRight").on('hide.bs.offcanvas', function (e) {
          if (dirty) {
            confirmDirtyNav(function() {
              dirty = false
              offcanvasRight.hide()
            })

            return e.preventDefault()
          }
        })

        $("#offcanvasRight").on('click', '#offcanvasRightHeaderNav button', function (e) {
          e.preventDefault()

          var link = $(this).data("link")
          // A record that has not been saved yet has no tab to go to: reloading would only blank what was typed.
          if (!link) return

          if (dirty) {
            confirmDirtyNav(function() {
              dirty = false
              fullscreenLoader.show()
              $.getScript(link)
            })

            return
          }

          fullscreenLoader.show()
          $.getScript(link)
        })

        userFunctions()
      }

      $('#sidebar').on('click', '.sidebar-header', function(event) {
        $(this).blur()
        $(this).removeClass('new_system_updates')
        $.getScript('/system_updates')
        mainModal.show()
      })

      // page specific code
      if (document.querySelectorAll(".clients.index").length) {
        clients_index()
      } else if (document.querySelectorAll(".contract_people.index").length) {
        contract_people_index()
      } else if (document.querySelectorAll(".customers.index").length) {
        customers_index()
      } else if (document.querySelectorAll(".dashboard-admin").length) {
        dashboard_admin()
      } else if (document.querySelectorAll(".dashboard-myyja").length) {
        dashboard_myyja()
      } else if (document.querySelectorAll(".dashboard-pem").length) {
        dashboard_pem()
      } else if (document.querySelectorAll(".quality_controls.index").length) {
        quality_controls_index()
      } else if (document.querySelectorAll(".users.index").length) {
        users_index()
      }
    }
  }

  // show toasts
  showToasts()
  var mutationObserver = new MutationObserver(function(mutations) {
    showToasts()
  });
  mutationObserver.observe(document.getElementById('toastContainer'), {
    childList: true,
    subtree: true
  });
})

function setTimeoutTimer(time_to_wait) {
  // Cancel any chain already pending before starting another. Both callers -- turbolinks:load and the Continue
  // button -- used to just reassign sessionTimer, which loses the handle without stopping the timeout: every page
  // visit left one more chain polling, and each of those can open the modal and start its own countdown (F-82).
  clearTimeout(sessionTimer)

  sessionTimer = setTimeout(function() {
    request.get('/sessions/check_time_until_logout')
      .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      .accept('json')
      .then(res => {
        // Both numbers come from the server (Users::SessionTimeoutController), so they cannot drift from
        // Devise.timeout_in the way two literals here did (T-73). ⚠️ The fallbacks are for bundle/server skew
        // only -- a page still running an older pack after a deploy -- NOT a second source of truth. Without
        // them a missing key gives NaN, `NaN <= 0` is false, and the user is signed out with no warning at all.
        const warnBefore = Number(res.body.warn_before) || 120
        const signOutBuffer = Number(res.body.sign_out_buffer) || 20
        const sessionTimeLeft = res.body.time_left - warnBefore

        if (sessionTimeLeft <= 0) {
          $('#session_timer').html(res.body.time_left)
          sessionModal.show()

          setTimeoutTimer2(res.body.time_left, signOutBuffer)
        } else {
          setTimeoutTimer(sessionTimeLeft * 1000)
        }
      })
      .catch(err => {
        handleErrors(err, null)
      })
  }, time_to_wait)
}

function setTimeoutTimer2(time_to_wait, signOutBuffer = 20) {
  clearTimeout(sessionTimer2)

  sessionTimer2 = setTimeout(function() {
    time_to_wait--
    $('#session_timer').html(time_to_wait)
    if (time_to_wait > signOutBuffer) {
      setTimeoutTimer2(time_to_wait, signOutBuffer)
    } else {
      signOut(null)
    }
  }, 1000)
}

function signOut(button) {
  // 📌 `?ms=false` was here, against a `params[:ms]` branch in `Users::SessionsController#destroy` that
  // redirected to Microsoft's logout endpoint. Microsoft sign-in was never in use and the whole feature
  // was removed 2026-10-12 (`TODO.md` F-119), so the parameter had nothing left to select.
  request.delete('/users/sign_out')
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept('json')
    .then(res => {
      dirty = false
      window.location.href = '/'
    })
    .catch(err => {
      handleErrors(err, button)
    })
}

function checkBackgroundJobStatus(jobId) {
  return request.get(`/background_jobs/${jobId}`)
    .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
    .accept('json')
    .then(res => {
      if (res.body.done < 0 && res.body.error_message) {
        addToast(res.body.error_message, 'error')
      }

      // F-69: the whole body, not just `done`. It carried progress/total all along and this threw them away.
      // ⚠️ Still RETURNS the body rather than taking a callback, so the ~15 existing waitForJob callers --
      // which only read `result` -- are untouched.
      return res.body
    });
}

// F-69. Writes "312 / 4000" under the loader's spinner, or clears it when there is nothing to show.
// ⚠️ Clears for a NULL total, not a zero one: a job with no countable work (ServiceDescriptionJob generates
// documents for one customer) never writes progress, and showing it 0% would read as stalled.
function updateLoaderProgress({ progress, total } = {}) {
  const el = document.getElementById('loaderProgress')
  if (!el) return

  // `total > 0` already excludes null/undefined/0 (both comparisons are false), and `progress != null` is
  // exactly "neither null nor undefined" — the four-clause form said the same thing twice.
  el.textContent = (total > 0 && progress != null) ? `${progress} / ${total}` : ''
}

// Helper: poll one job until it returns 1 or -1.
// `onProgress` (F-69) receives { progress, total } on every poll, and DEFAULTS to the loader updater — so
// all ~15 existing callers show progress without being touched, which is why this is a default rather than
// something each call site opts into. Pass `onProgress: null` to suppress it, or your own function to render
// it somewhere else.
//
// ⚠️ **Clearing goes through `onProgress` too, not `updateLoaderProgress` directly** (fixed 2026-10-01,
// `/code-review`). Otherwise a caller's own renderer was never cleared when the job ended, while the shared
// loader element it had never written to was cleared anyway — and `onProgress: null`, documented above as
// "suppress it", still touched `#loaderProgress`.
//
// ⚠️ **One readout, so concurrent waits fight over it.** `functions_contract.js` and
// `functions_service_description.js` run two or three `waitForJob` promises under `Promise.all`: the count
// flips between them and the first to finish blanks it while the others are still going. Acceptable today
// because the loader is modal and the numbers are advisory, but a caller that needs its own figure must pass
// its own `onProgress` — which now also owns the clearing.
window.waitForJob = function(jobId, { intervalMs = 1000, timeoutMs = 0, onProgress = updateLoaderProgress } = {}) {
  // Whatever renders the progress is what clears it. A no-arg call is the documented "nothing to show".
  const clearProgress = () => { if (onProgress) onProgress({ progress: null, total: null }) }

  return new Promise((resolve, reject) => {
    const start = Date.now();

    const tick = () => {
      // `checkBackgroundJobStatus` is `request.get(...).then(res => res.body)`, so it always resolves an
      // object. The earlier version defended against a sync caller and a bare-number body — neither of
      // which that function can produce, and nothing stubs it (module-local, and feature specs run the
      // real JS). Three variables and two typeof tests for one object.
      checkBackgroundJobStatus(jobId)
        .then(({ done, progress, total }) => {
          if (onProgress) onProgress({ progress, total });

          if (done === 1 || done === -1) {
            // Stop polling for this job. Clear the readout first, or the next wait opens showing the last
            // job's final count until its own first poll lands.
            clearProgress()
            return resolve({ jobId, result: done });
          }

          if (timeoutMs && Date.now() - start >= timeoutMs) {
            clearProgress()
            return reject(new Error(`Job ${jobId} timed out after ${timeoutMs} ms`));
          }

          // Schedule next poll in 1s
          setTimeout(tick, intervalMs);
        })
        .catch((err) => { clearProgress(); reject(err) }); // surface errors from checkBackgroundJobStatus
    };

    // start immediately
    tick();
  });
}
